// extracted by mini-css-extract-plugin
export default {"border":"#d1d1d1","text-field-input":"TextField_text-field-input__t8X3v"};